// BORDER-RADIUS
export const BORDER_RADIUS_400 = '32px';

// FONT-SIZE
export const FONT_SIZE_900 = '40px';
export const FONT_SIZE_1000 = '45px';
